import { useFlags } from 'launchdarkly-react-client-sdk';
import { PermissionService } from '../services/PermissionService';
import { MaggieFeatureFlags } from '../util/feature-flags';

/**
 * A fund admin sees only what their fund grant opens, once the rollout flag is on, as in the API.
 * The API evaluates the flag for a tenant context and the browser for a user context, so they agree only
 * while the flag is a plain on/off with no targeting rules.
 */
export function useIsFundAdmin(): boolean {
  const { showFundAdminAccessConfig } = useFlags<MaggieFeatureFlags>();
  return (
    Boolean(showFundAdminAccessConfig) &&
    PermissionService.isInitialized() &&
    PermissionService.get().isFundAdmin()
  );
}
